import React, { ReactElement, useEffect } from 'react';
import moment from 'moment-timezone';
import SnapshotTabsBase, { ISnapshotTab } from './SnapshotTabsBase';
import {
  endpointEnum,
  makeApiRequestCached,
} from '../../../../services/rest/makeAPIRequest';
import { methodNameEnum } from '../../../../recoil/selectors/makePHPRequest';
import { momentTz } from '../../subheader/components/DatePicker';

const SnapshotDateTabs = (props: {
  children: ReactElement;
  onSetDates: any;
}) => {
  const { onSetDates, children } = props;
  const [value, setValue] = React.useState(0);
  const dateSnapshotTabs: ISnapshotTab[] = [
    {
      label: 'Today',
    },
    {
      label: 'This Week',
    },
    {
      label: 'This Month',
    },
    {
      label: 'This Quarter',
    },
  ];
  useEffect(() => {
    setDates(moment().startOf('day'), moment(), 0);
  }, []);
  const [
    businessTimezoneCached,
    // businessTimezoneLoadable,
  ] = makeApiRequestCached<string | undefined>(
    {
      endpoint: endpointEnum.GET_BUSINESS_DATA,
      payloadJsonString: JSON.stringify({
        call: methodNameEnum.GET_BUSINESS_DATA,
      }),
    },
    (loadable, cached) =>
      loadable.contents?.response?.data?.result?.[0]?.timezone_php ??
      cached.current
  );

  const setDates = (
    start: moment.Moment,
    end: moment.Moment,
    index: number
  ) => {
    const localStart = momentTz(
      start.format('YYYY-MM-DDTHH:mm:ss.SSS'),
      businessTimezoneCached.current
    );

    const localEnd = momentTz(
      end.format('YYYY-MM-DDTHH:mm:ss.SSS'),
      businessTimezoneCached.current
    );
    onSetDates(localStart, localEnd, index);
  };

  const handleChange = (event: any, newValue: any) => {
    switch (newValue) {
      case 0:
        setDates(moment().startOf('day'), moment(), newValue);
        break;
      case 1:
        setDates(moment().startOf('week'), moment(), newValue);
        break;
      case 2:
        setDates(moment().startOf('month'), moment(), newValue);
        break;
      case 3:
        setDates(
          moment().quarter(moment().quarter()).startOf('quarter'),
          moment(),
          newValue
        );
        break;
    }
    setValue(newValue);
  };
  return (
    <SnapshotTabsBase
      onHandleChange={handleChange}
      value={value}
      tabs={dateSnapshotTabs}
    >
      {children}
    </SnapshotTabsBase>
  );
};
export default SnapshotDateTabs;
